"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkWMYJ7ELBjs = require('./chunk-WMYJ7ELB.js');var _chunkU6NJVEOJjs = require('./chunk-U6NJVEOJ.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _react = require('react');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var c=_styled2.default.call(void 0, _chunkWMYJ7ELBjs.a)`
  border-radius: 50%;
  padding: ${o=>o.theme.measurements.spacing(7)};
  background: ${o=>o.$buttonColor};
  border-color: ${o=>o.$buttonColor};
  transition: 0.5s;

  &:hover,
  &:active,
  &:focus {
    background: ${o=>o.$buttonColor};
    border-color: ${o=>o.$buttonColor};
    transform: scale(1.1);
  }

  svg {
    color: ${o=>o.theme.palette.WHITE};
  }
`;function i({topicColor:o}){let l=_chunkOL2KRAIPjs.b.call(void 0, ).VIOLET,a=_react.useMemo.call(void 0, ()=>o||l,[o]);return _jsxruntime.jsx.call(void 0, c,{size:"large",$buttonColor:a,children:_jsxruntime.jsx.call(void 0, _chunkU6NJVEOJjs.b,{height:12,width:12})})}var y=i;exports.a = y;
